import { Modal, Form, Input, Select } from 'antd';
import { APPOINTMENT_STATES } from 'constants/appointments';
import { useModalStateContext, useUIDispatchContext } from 'providers/UI';
import { FC, memo, useEffect, useMemo, useState } from 'react';
import { updateAppointmentState as updateAppointmentStateApi } from 'services/api/appointments';
import { AppointmentState } from 'types/api/appointments';

import { useAppointmentDetail } from 'pages/AppointmentsDetails/AppointmentDetailContext';
import { showErrorMessage } from 'utils/showErrorMessage';

const { TextArea } = Input;

const StateModal: FC = () => {
  // form
  const [form] = Form.useForm();
  // context
  const { appointmentState } = useModalStateContext();
  const { toggleModal } = useUIDispatchContext();
  const { appointment, refresh } = useAppointmentDetail();
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    toggleModal('appointmentState', false);
    form.resetFields();
  };

  const adminNote = useMemo(
    () => appointment?.admin_notes?.[0]?.note,
    [appointment?.admin_notes]
  );

  useEffect(() => {
    if (appointmentState.visible) {
      form.setFieldsValue({
        state: appointment?.state ?? undefined,
        note: adminNote
      });
    }
  }, [adminNote, appointment, appointmentState.visible, form]);

  const onFinish = async (values: {
    note: string;
    state: AppointmentState;
  }) => {
    const id = appointmentState.params?.id;
    if (!id) return;

    try {
      setLoading(true);
      await updateAppointmentStateApi(id, values.state, values.note || '');
      closeModal();
      refresh();
    } catch (err) {
      showErrorMessage(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Appointment State"
      open={appointmentState.visible}
      onOk={form.submit}
      onCancel={closeModal}
      confirmLoading={loading}
    >
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Form.Item label="State" name="state" rules={[{ required: true }]}>
          <Select
            options={Object.entries(APPOINTMENT_STATES).map(
              ([value, label]) => ({
                label,
                value
              })
            )}
          />
        </Form.Item>
        <Form.Item label="Notes" name="note" rules={[{ required: false }]}>
          <TextArea style={{ height: 130 }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default memo(StateModal);
